export default __webpack_public_path__ + "static/media/Scenery03.881bfb16.jpg";